var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModuleOrder(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 23,
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "border-fill",
    fill: "#6467EF",
    d: "M21.192 17.088a1.905 1.905 0 01-1.903-1.912c0-1.058.85-1.912 1.903-1.912 1.054 0 1.904.854 1.904 1.912 0 1.058-.85 1.912-1.904 1.912M13.02 5.736a1.904 1.904 0 01-1.903-1.912 1.904 1.904 0 113.807 0c0 1.058-.85 1.912-1.904 1.912M4.808 17.088a1.905 1.905 0 01-1.904-1.912c0-1.058.85-1.912 1.904-1.912 1.053 0 1.903.854 1.903 1.912 0 1.058-.85 1.912-1.903 1.912m15.176-5.522l-4.683-4.703a3.82 3.82 0 001.527-3.039A3.82 3.82 0 0013.02 0a3.81 3.81 0 00-3.807 3.824c0 1.242.601 2.34 1.522 3.04l-4.691 4.712a3.734 3.734 0 00-1.236-.224A3.81 3.81 0 001 15.176C1 17.278 2.7 19 4.808 19c2.094 0 3.807-1.722 3.807-3.824 0-.986-.38-1.873-.99-2.55h.064l4.657-4.678a.955.955 0 011.346 0l4.658 4.678h.02a3.807 3.807 0 00-.985 2.55c0 2.102 1.7 3.824 3.807 3.824C23.287 19 25 17.278 25 15.176a3.819 3.819 0 00-3.808-3.824c-.425 0-.826.085-1.208.214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "background",
    fill: "#4E39FF",
    fillOpacity: 0.253,
    d: "M22.94 13.914l-5.66-5.657c1.112-.844 1.845-2.164 1.845-3.656A4.605 4.605 0 0014.525 0a4.593 4.593 0 00-4.601 4.6 4.58 4.58 0 001.839 3.657l-5.669 5.67a4.484 4.484 0 00-1.493-.27A4.594 4.594 0 000 18.257a4.605 4.605 0 004.6 4.601 4.615 4.615 0 004.601-4.6c0-1.186-.46-2.254-1.196-3.068h.077l5.628-5.628a1.157 1.157 0 011.626 0l5.628 5.628h.025a4.57 4.57 0 00-1.19 3.067 4.605 4.605 0 004.6 4.601 4.616 4.616 0 004.601-4.6 4.604 4.604 0 00-4.6-4.601c-.514 0-1 .102-1.46.257z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleOrder);
export default __webpack_public_path__ + "static/media/module-order.e0be845f.svg";
export { ForwardRef as ReactComponent };